<div class="plans-container" [ngClass]="cardType()">
  @for (plan of plans(); track plan.id) {
    @if (plan.name === 'changedTest') {
    } @else {
      <div class="plan-card" [ngClass]="cardType()" [class.active]="plan.id === activePlanId()">
        <div class="plan-card__upper">
          <h2 class="heading-sm plan-title">{{ plan.name | translate }}</h2>
          <p class="heading-lg-strong price">{{ plan.monthlyPrice | subPrice }}</p>
          <p class="secondary-text description">
            {{ plan.description | translate }}
          </p>
          <hr class="divider" />
          <ul class="plan-features">
            @for (feature of plan.planFeature; track feature) {
              <li class="subtitle-sm plan-feature" [class.inactive]="!feature.checked">
                <div>
                  <app-icon
                    [icon]="
                      feature.checked ? iconName.PASSWORD_HINT_CHECK : iconName.PASSWORD_HINT_CROSS
                    "
                  />
                </div>
                {{ feature.name | translate }}
              </li>
            }
          </ul>
        </div>
        <button
          class="option plan-btn"
          [routerLink]="useRouterLink() ? appRoutes.SIGN_UP : null"
          [disabled]="plan.id === activePlanId()"
          (click)="tryChangeSubscription(plan.id)"
        >
          {{ getButtonText(plan) | translate }}
        </button>
        @if (plan.id === popularPlanId()) {
          <div class="emphasis popular-badge">
            {{ 'mainPageComponent.plansBanner.mostPopular' | translate }}
          </div>
        }
      </div>
    }
  }
</div>
